import React from 'react';
import $ from 'jquery';
import styled from 'styled-components';

import './modal.scss';

interface Props {
  title: string;
  close: Function;
  id: string;
}

const Title = styled.div`
  font-family: BrandonGrotesque-Bold;
  font-size: 18px;
  text-align: center;
  font-style: italic;
  color: var(--color-gunmetal);
  padding-top: 10px;
`;

const Subtitle = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  color: var(--color-gunmetal);
  padding-bottom: 15px;
`;

class AttendeeList extends React.Component<Props> {
  componentDidMount() {
    $(`#${this.props.id}`).modal('show');
    $(`#${this.props.id}`).on('hidden.bs.modal', (e) => this.props.close());
  }

  render() {
    return (
      <div className="modal fade" id={this.props.id} role="dialog">
        <div className="modal-dialog" style={{ width: '400px' }}>
          <div className="modal-content">
            <div style={{ paddingTop: '10px' }}>
              <Title>{this.props.title}</Title>
              <div className="content">{this.props.children}</div>
              <button className="close-button" data-dismiss="modal">
                OKAY
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AttendeeList;
